import { Moment } from 'moment-mini'

export enum BlacklistWhitelistDays {
  EVERY_DAY = null,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7
}

export class CompetitionBlacklist {
  id: number
  weekday: number
  memberId: number
  competitionId: number
  competitionTeamId: number
  startDate: Moment
  endDate: Moment
}
